import type { LegalPageProps } from "@op/puck-types";
import { RichTextRenderer } from "../../../../../renderer/RichTextRenderer";
import { DefaultLinkComponent, ThemeNav } from "./ThemeNav";
import { ThemeFooter } from "./ThemeFooter";

const LegalPage = ({
  languageKey,
  languages,
  heading,
  content,
  logoImage,
  copyrightText,
  imprintLink,
  privacyLink,
  hasImprint,
  hasPrivacyPolicy,
  organizationName,
  organizationLink,
  LinkComponent = DefaultLinkComponent,
}: LegalPageProps) => {
  return (
    <div className="min-h-screen flex flex-col justify-between items-center">
      <div className="w-full flex flex-col justify-center items-center">
        <ThemeNav
          languageKey={languageKey}
          languages={languages}
          logoImage={logoImage}
          organizationName={organizationName}
          organizationLink={organizationLink}
          LinkComponent={LinkComponent}
        />
        <div className="flex flex-col w-full max-w-[1024px] mt-24 px-8 py-16 gap-8">
          <h1 className="text-heading-1 font-heading-1 text-default-font">
            {heading}
          </h1>
          {content && <RichTextRenderer content={content} />}
        </div>
      </div>
      <ThemeFooter
        copyrightText={copyrightText}
        imprintLink={imprintLink}
        privacyLink={privacyLink}
        hasImprint={hasImprint}
        hasPrivacyPolicy={hasPrivacyPolicy}
        languageKey={languageKey}
        LinkComponent={LinkComponent}
      />
    </div>
  );
};

export default LegalPage;
